// extracted by mini-css-extract-plugin
module.exports = {"integrationCategory":"IntegrationCategoryCard_integrationCategory__Jsge2","categoryDescription":"IntegrationCategoryCard_categoryDescription__Asp_E"};